import React from "react";

const CheckmarkIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.52533 5.85L9.17533 0.2C9.30867 0.0666667 9.46422 0 9.642 0C9.81978 0 9.97533 0.0666667 10.1087 0.2C10.242 0.333333 10.3087 0.491667 10.3087 0.675C10.3087 0.858333 10.242 1.01667 10.1087 1.15L3.992 7.28333C3.85867 7.41667 3.70311 7.48333 3.52533 7.48333C3.34756 7.48333 3.192 7.41667 3.05867 7.28333L0.192 4.41667C0.0586667 4.28333 -0.00522222 4.125 0.000333333 3.94167C0.00588889 3.75833 0.0753333 3.6 0.208667 3.46667C0.342 3.33333 0.500333 3.26667 0.683667 3.26667C0.867 3.26667 1.02533 3.33333 1.15867 3.46667L3.52533 5.85Z"
        fill="#BE2BBB"
      />
    </svg>
  );
};

export default CheckmarkIcon;
